<template>
  <section class="header_view">
    <div class="header_top">
      <div class="header_left">
        <img
          :src="require('@/assets/image/icon/san.png')"
          alt=""
          class="icon_san"
          @click="popupShow = true"
        />
        <img
          :src="require('@/assets/image/icon/logo.png')"
          alt=""
          class="icon_logo"
        />
      </div>
      <div class="header_right">
        <div @click="aheftBut()" class="consult">
          <img :src="require('@/assets/image/wa.png')" alt="" />{{ $t('other_pages.manual_consultation') }}
        </div>
        <div class="language-selector">
          <img
            :src="require('@/assets/image/icon_switch_language.png')"
            alt=""
            @click="lang_popupShow = true"
            class="language-icon"
          />
          <van-dialog
            v-model="lang_popupShow"
            show-cancel-button
            :title="$t('other_pages.select_language')"
            @confirm="confirmLanguage"
            @cancel="cancelLanguage"
            :confirm-button-text="$t('other_pages.confirm')"
            :cancel-button-text="$t('other_pages.cancel')"
          >
            <van-radio-group
              v-model="selectedLanguage"
              direction="vertical"
              class="radio-group"
            >
              <van-radio
                v-for="(language, index) in languages"
                :key="index"
                :name="language.code"
                class="radio-item"
              >
                {{ language.name }}
              </van-radio>
            </van-radio-group>
          </van-dialog>
        </div>
      </div>
    </div>

    <van-popup
      v-model="popupShow"
      position="left"
      :style="{ height: '100%', width: '50%' }"
    >
      <div class="box">
        <ul>
          <li
            v-for="(item, index) in nav"
            :key="index"
            @click="but(item)"
            :class="select == item.id ? 'select' : ''"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </van-popup>
  </section>
</template>

<script>
import home from "@/mixin/home_mixin";
import { Popover } from "vant";
export default {
  name: "header_view",
  data() {
    return {
      nav: [
        {
          id: 0,
          name: this.$t('other_pages.home_page'),
          path: "/",
          href: null,
          type: 1, //1是本地跳轉   2,pdf預覽   3,外鏈
        },
        // {
        // 	id:1,
        // 	name:'比賽指引',
        // 	path:'/',
        //   href:null,
        // },
        {
          id: 2,
          name: this.$t('other_pages.competition_materials'),
          path: "/material",
          href: null,
          type: 1, //1是本地跳轉   2,pdf預覽   3,外鏈
        },
        // {
        //   id: "2",
        //   name: this.$t('other_pages.competition_materials'),
        //   path: "/",
        //   href: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/image/15b7103e9d1c71e09264611df669ff29.pdf",
        //   type: 3, //1是本地跳轉   2,pdf預覽   3,外鏈
        // },
        {
          id: 3,
          name: this.$t('other_pages.results_announcement'),
          path: "/achievement",
          href: null,
          type: 1, //1是本地跳轉   2,pdf預覽   3,外鏈
        },
        // {
        //   id: "4",
        //   name: "比赛章程",
        //   path: "/constitution",
        //   href: null,
        //   type: 1, //1是本地跳轉   2,pdf預覽   3,外鏈
        // },
        {
          id: 4,
          name: this.$t('other_pages.competition_rules'),
          path: "/",
          href: "https://chineserd-audio-1256597606.cos.accelerate.myqcloud.com/readingcontest/id/competition_regulations.pdf",
          type: 3, //1是本地跳轉   2,pdf預覽   3,外鏈
        },
        {
          id: 5,
          name: this.$t('other_pages.app_download'),
          path: "/",
          href: "https://school.chineserd.com/#/download-student",
          type: 3, //1是本地跳轉   2,pdf預覽   3,外鏈
        },
      ],
      popupShow: false,
      lang_popupShow: false,
      languages: [
        {
          name: "简体中文",
          code: "zh_CN",
        },
        {
          name: "Bahasa Indonesia",
          code: "id_ID",
        },
      ],
      selectedLanguage: this.$i18n.locale,
      previousLanguage: this.$i18n.locale, // 用于取消时恢复之前的语言
    };
  },
  computed: {
    selectedLanguageName() {
      const selected = this.languages.find(
        (lang) => lang.code === this.selectedLanguage
      );
      return selected ? selected.name : "";
    },
  },
  props: {
    select: {
      type: String,
      default: "0",
    },
  },
  components: {
    [Popover.name]: Popover,
  },
  components: {},
  mixins: [home],
  watch: {},
  created() {},
  mounted() {},
  methods: {
    confirmLanguage() {
      this.$i18n.locale = this.selectedLanguage;
      // 刷新页面
      location.reload();
      // this.lang_popupShow = false;
      localStorage.setItem("i18n", this.selectedLanguage);
    },
    cancelLanguage() {
      this.selectedLanguage = this.previousLanguage;
      this.lang_popupShow = false;
    },
    aheftBut(e) {
      this.home_mdevInit();
      window.open("https://wa.me/6281334941415", "_blank");
    },
    heftBut(e) {
      this.$router.push(e);
    },
    but(e) {
      if (e.id == this.select) {
        console.log("不生效");
        this.popupShow = false;
      } else {
        console.log(e);

        switch (e.type) {
          case 1:
            this.$router.push(e.path);
            break;
          case 2:
            let baseurl =
              "http://chineserd.cn/h5/html/regulations/index.html?url=" +
              e.href;
            window.open(baseurl, "_blank");
            break;
          case 3:
            window.open(e.href, "_blank");
            break;
          default:
            break;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header_view {
  width: 100%;
  height: 0.92rem;
  background-color: #ff891f;
  padding: 0rem 0.32rem;
  box-sizing: border-box;

  .header_top {
    position: fixed;
    top: 0;
    left: 0;

    width: 100%;
    height: 0.92rem;
    background-color: #ff891f;
    padding: 0rem 0.32rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 2000;

    .header_left {
      display: flex;
      align-items: center;

      .icon_san {
        width: 0.48rem;
        height: 0.48rem;
        margin-right: 0.32rem;
      }

      .icon_logo {
        width: 0.56rem;
        height: 0.68rem;
      }
    }
    .header_right {
      display: flex;
      align-items: center;
      .language-selector {
        margin-left: 0.32rem;
        display: flex;
        align-items: center;
        position: relative;
        img {
          width: 0.58rem;
        }

        .radio-group {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
		  text-align:left;
		  margin:0.32rem;
        }

        .radio-item {
          margin-bottom: 0.32rem;
        }
      }
      .language-icon {
        cursor: pointer;
        margin-right: 0.08rem;
      }
    }
    .consult {
      background: #ffffff;
      border-radius: 0.4rem;
      box-sizing: border-box;
      font-size: 0.28rem;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff891f;
      padding: 0.15rem 0.44rem;
      vertical-align: middle; /* 将图片和文本垂直居中对齐 */

      img {
        width: 20px;
        height: 20px;
        margin-right: 4px;
        vertical-align: middle; /* 将图片和文本垂直居中对齐 */
      }
    }
  }

  .box {
    width: 100%;
    height: 100%;
    padding: 0.92rem 0 0 0;
    box-sizing: border-box;
    text-align: left;
    line-height: 1.15;
    ul {
      width: 100%;
      height: 100%;

      li {
        width: 100%;
        height: 1.52rem;
        padding-left: 0.32rem;
        box-sizing: border-box;
        font-size: 0.4rem;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }

      .select {
        background: #f97226;
        color: #ffffff !important;
      }
    }
  }
}
</style>
